import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useCallback } from 'preact/hooks';
import { Prefectures } from '../../../const/prefecture';
import ErrorMessage from './ErrorMessage';
Object.entries(Prefectures).sort();
const PrefectureSelect = ({ value, errors, onInput }) => {
    const hasError = Object.entries(errors ?? {}).filter(error => error[0] === "prefectureCode").length;
    const handleSelect = useCallback((evt) => {
        const prefectureCode = evt.currentTarget.value;
        onInput("prefectureCode", prefectureCode);
        const prefecture = Object.entries(Prefectures).find(prefecture => prefecture[0] === prefectureCode);
        if (prefecture) {
            onInput("prefectureName", prefecture[1]);
        }
    }, []);
    return (_jsxs("div", Object.assign({ className: "field" }, { children: [_jsx("label", Object.assign({ className: "label" }, { children: "\u90FD\u9053\u5E9C\u770C" }), void 0),
            _jsxs("select", Object.assign({ className: `input ${hasError > 0 ? 'is-danger' : ''}`, value: value.prefectureCode, onInput: handleSelect }, { children: [_jsx("option", Object.assign({ value: "" }, { children: "\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044" }), void 0),
                    Object.entries(Prefectures).sort().map(prefecture => (_jsx("option", Object.assign({ value: prefecture[0] }, { children: prefecture[1] }), void 0)))] }), void 0),
            _jsx(ErrorMessage, { field: "prefectureCode", errors: errors }, void 0)] }), void 0));
};
export default PrefectureSelect;
